export default "__VITE_ASSET__BgEiZ8Dz__"